import {
  InternalUserAccountsShape,
  AccountDetailsShape,
  // eslint-disable-next-line import/no-unresolved
} from '@gogoair/utils/build/types/Globals/src/types';
import { getApiData, postApi, postPasswordResetApi } from '../lib/restUtils';
import { OtaComplianceAccount } from '../types/global_reducer';

const apiUrl = '/api';
const API_VERSION = 'v1';

/* pull down all aircraft for this account */
// eslint-disable-next-line import/prefer-default-export
export const apiGetInternalAccounts = () => {
  // bend api: http://aircraft.dashdata.dev.gogoair.com/v1/accounts
  const apiURL = `${apiUrl}/${API_VERSION}/accounts`;
  return getApiData<(InternalUserAccountsShape | AccountDetailsShape)[]>(apiURL);
};

export const apiForgotPassword = (email: string) => {
  const apiURL = `${apiUrl}/${API_VERSION}/forgotPassword`;
  return postPasswordResetApi<void>(apiURL, { email });
};

export const apiGetOtaCompliance = (accounts: string[]) => {
  const apiURL = `${apiUrl}/${API_VERSION}/softwareCompliance/summaries`;
  return postApi<Omit<OtaComplianceAccount, 'accountName'>[]>(apiURL, accounts);
};

export const apiPostComplianceAcknowledgement = (accounts: string[]) => {
  const apiURL = `${apiUrl}/${API_VERSION}/softwareCompliance/acknowledged`;
  return postApi<Record<string, never>>(apiURL, accounts);
};
